import { useSelector } from "react-redux";
import useAddPost from "../hooks/useAddPost";
import { RootState } from "@/store/reducers";
import { useEffect } from "react";
import { InputField, UploadImageField } from "@/components/Form";
import { Button, Image, ImageList, LinkIc } from "@/components/Elements";
import { PostHeader } from "./addPost";
import {
  AIInput,
  LocationMapView,
  SearchPinCode,
} from "@/features/misc/components";
import { useUrlTitle } from "@/hooks";
import { FileModel } from "@/types/common";
import { PostType } from "../types";

export const AddPostScreen = () => {
  const {
    formState,
    getValues,
    register,
    setValue,
    postHeaderDetail,
    handleUploadImg,
    handleSubmit,
    handleDraft,
  } = useAddPost({ type: PostType.Post });
  const { location, files, externalLinks } = getValues();
  const { title } = useUrlTitle({ url: externalLinks ? externalLinks : "" });
  const distanceRadius = useSelector(
    (state: RootState) => state.login.userDetail.distanceRadius
  );

  useEffect(() => {
    if (title) {
      setValue("description", title);
    }
  }, [title]);

  const hasLocation = location && distanceRadius;

  return (
    <>
      <div className="p-0 mt-[10px] pb-[10px]">
        <div className="flex p-[5px]">
          <PostHeader {...postHeaderDetail} />
        </div>
        <div>
          <AIInput setValue={setValue} />
        </div>
        <div className="maz-h-[45%]">
          <InputField
            type="text"
            placeholder="Write something here..."
            registration={register("description")}
            error={formState.errors["description"]}
            className="text-[20px]"
          />
        </div>
        <div className="p-[17px] border-b border-b-[#d3d3d3]">
          <UploadImageField name="file" setValue={handleUploadImg}>
            <div className="flex">
              <Image src="add-image.png" className="w-[25px] h-[25px]" />
              <div className="text-[15px] ml-4 text-center">
                Add Image/Video
              </div>
            </div>
          </UploadImageField>
          {files && (
            <ImageList
              files={files}
              handleChange={(value: FileModel[]) => setValue("files", value)}
              showRemove
            />
          )}
        </div>
        <div className="p-[17px] border-b border-b-[#d3d3d3]">
          <SearchPinCode
            location={location}
            onChange={setValue}
            radius={distanceRadius}
          >
            <Image src="add-location.png" className="w-[25px] h-[25px]" />
            <div className="text-[15px] ml-4 text-center">Add Location</div>
          </SearchPinCode>
        </div>
        <div className="p-[17px]">
          <div className="flex items-center">
            <LinkIc className="w-[25px] h-[25px] text-[#ff9f33]" />
            <InputField
              type="text"
              placeholder="Instagram/Youtube Link(s)"
              registration={register("externalLinks")}
              className="ml-[20px]"
            />
          </div>
        </div>
      </div>
      <div className="flex justify-between">
        {hasLocation && (
          <LocationMapView location={location} radius={distanceRadius} />
        )}
        <Button onClick={handleSubmit(handleDraft)} className="w-[49%]">
          Post
        </Button>
      </div>
    </>
  );
};
